var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_cof.js
// module id = 63
// module chunks = 48 49 50 51